export { default } from './AutoCompleteWithLabel.js';
